import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { AddCreditComponent } from '../add-credit/add-credit.component';
import { AppService } from 'src/@core/services/app.service';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions';
import { WithdrawComponent } from '../withdraw/withdraw.component';
import { CreditsService } from 'src/@core/services/credits/credits.service';
import { HttpParams } from '@angular/common/http';
import { EmployementPaymentOrder } from 'src/@core/interfaces/employment/employement-payment-order.model';
import { environment } from 'src/environments/environment';
import { EmployeerPaymentOrderService } from 'src/@core/services/employment/employment-payment-order.service';
import { Router } from '@angular/router';
import { NotificationService } from 'src/@core/services/notification.service';
import moment from 'moment';
import { TwilioService } from 'src/@core/services/twilio.service';
import { EnterpriseAdminService } from '../../enterprise-admin/enterprise-admin.service';
import { UpgradeSubscriptionPopupComponent } from '../upgrade-subscription-popup/upgrade-subscription-popup.component';
import { TrialEndedPopupComponent } from '../trial-ended-popup/trial-ended-popup.component';
import { SubscriptionPlansService } from '../../subscription-plans/subscription-plans.service';
declare var Razorpay: any;
@Component({
  selector: 'hour4u-admin-credit-list',
  templateUrl: './credit-list.component.html',
  styleUrls: ['./credit-list.component.scss']
})
export class CreditListComponent implements OnInit {
  resultsLength: number = 0;
  creditList: any[] = [];
  isLoading: boolean = false;
  isLoadingWalletBalance: boolean = false;
  isLoadingTaskCredit: boolean = false;
  diameter = 40;
  diameter1 = 30;
  color: string;
  mode = 'indeterminate';
  columns = [
    { columnDef: 'enterprise', visible: true, label: 'Enterprise' },
    { columnDef: 'amount', visible: true, label: 'Requested amount' },
    { columnDef: 'paymentStatus', visible: true, label: 'Payment status' },
    { columnDef: 'status', visible: true, label: 'Credit status' },
    // { columnDef: 'creditType', visible: true, label: 'Credit Type' },
    { columnDef: 'receivedAmount', visible: true, label: 'Received credit' },
    // { columnDef: 'rechargeType', visible: true, label: 'Type' },
    // { columnDef: 'toBePaidBy', visible: true, label: 'Duration' },
    { columnDef: 'toBePaid', visible: true, label: 'Amount to be paid' },
    { columnDef: 'action', visible: true, label: 'Action' },
  ];
  displayedColumns = this.columns.map(x => x.columnDef);
  profile = this.appService.getCurrentAccount();
  roles = roles;
  entityTypes = entityTypes;
  permissions = permissions;
  totalCredits: any = null;
  walletBalance: any = null;
  pageIndex = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isExporting: boolean = false;
  selectedTabIndex: any;
  creditUsageDetails: any = null;
  selected: any = "";
  job: any;

  ranges: any = {
    'Today': [moment()],
    'Yesterday': [moment().subtract(1, "days")],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
  }
  selectedWorkorder: any = "";
  typeList: any = [];
  selectedType: any = "";
  workordersList: any[] = [];
  dataSource = [];
  currentUserSubscription: any;

  constructor(
    private dialog: MatDialog,
    private appService: AppService,
    public creditsService: CreditsService,
    private zone: NgZone,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private notify: NotificationService,
    private twilioService: TwilioService,
    public enterpriseAdminService: EnterpriseAdminService,
    public subscriptionPlansService: SubscriptionPlansService
  ) { }

  ngOnInit() {
    console.log("xxxxxxx")
    if (true) {
      this.fetchWalletBalance();
      this.fetchTaskCredits();
      this.getCurrentUserSubscription();
      this.columns = this.columns.map(x => {
        x.visible = true;
        if (x.columnDef === 'enterprise')
          x.visible = false;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }

    if (this.profile.entity.entityType === 'INTERNAL') {
      this.columns = this.columns.map(x => {
        x.visible = true;
        if (x.columnDef === 'rechargeType')
          x.visible = false;
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngAfterViewInit() {
    console.log("ccccc")
    this.fetchRechargeRequests();
    //this.fetchUsageData();
  }

  private getAllCalls(maxPageSize: number, pageNum: number) {
    this.dataSource = [];
    this.isLoading = true;
    this.enterpriseAdminService.getCallHistory(this.profile.entity.id, "", maxPageSize, pageNum).subscribe(res => {
      this.isLoading = false;
      if (res && res.records && res.records.length) {
        this.dataSource = res.records;
        this.dataSource.forEach(ele => {
          if (ele.start_time) {
            ele.start_time = this.formatStartTime(ele.start_time);
          }
        })
        console.log(this.dataSource);
      }
    }, (err => {
      this.isLoading = false;
      console.log(err);
    }))
    // this.twilioService.getAllCalls()
    //   .then((response: any) => {
    //     this.isLoading = false;
    //     this.dataSource = response.calls;
    //     console.log('Calls List:', this.dataSource);
    //   })
    //   .catch(error => {
    //     console.error('Error fetching calls list:', error);
    //     this.isLoading = false;
    //   });
  }

  formatStartTime(value: any): string {
    const timestamp = parseFloat(value) * 1000; // Convert to milliseconds
    const date = new Date(timestamp);

    // Get the day, month, and year
    const day = date.getDate();
    const month = this.getMonthAbbreviation(date.getMonth()); // Get month abbreviation (e.g., "Dec")
    const year = date.getFullYear();

    // Get the time components (hours, minutes, seconds)
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Format time in 12-hour format with AM/PM
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = this.padNumber(minutes);
    const formattedSeconds = this.padNumber(seconds);

    // Return formatted string like 'Dec 31, 2024, 5:04:39 PM'
    return `${month} ${day}, ${year}, ${formattedHours}:${formattedMinutes}:${formattedSeconds} ${period}`;
  }

  // Helper method to get month abbreviation (e.g., 'Jan' for January)
  getMonthAbbreviation(month: number): string {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return months[month] || '';
  }

  // Helper method to pad single digits for minutes and seconds
  padNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  getTotalDuration() {
    // Sum up all valid durations in seconds
    const totalSeconds = this.dataSource
      .filter(call => call.duration && !isNaN(parseFloat(call.duration)))
      .reduce((acc, call) => acc + parseFloat(call.duration), 0);

    // Calculate hours, minutes, and seconds
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    // Format as a string
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  getTotalCredits() {
    const totalCredits = this.dataSource
      .filter(ele => ele.credit_used && !isNaN(parseFloat(ele.credit_used)))
      .reduce((acc, ele) => acc + parseFloat(ele.credit_used), 0);

    return totalCredits.toFixed(2);
  }


  fetchRechargeRequests() {
    this.isLoading = true;
    // Add placeholder rows for skeleton loading
    this.creditList = Array(this.pageSize).fill({});
    let params = new HttpParams()
      .set('page', this.pageIndex.toString())
      .set('size', this.pageSize.toString())
      .set('sort', 'createdAt,desc'); // Sorting parameter

    if (this.profile.entity.entityType === 'ENTERPRISE' || this.profile.entity.entityType === 'AGENCY'
      || this.profile.entity.entityType === 'AGENT'
    ) {
      params = params.set('entityId', this.profile.entity.id);
    }
    this.paginator.pageIndex = this.pageIndex;
    this.paginator.pageSize = this.pageSize;

    this.creditsService.fetchRechargeRequestsList(params).subscribe(
      (response) => {
        this.isLoading = false;
        if (response.content && response.content.length) {
          response.content.forEach(element => {
            element.metaDataJson = JSON.parse(element.metaData);
          });
          this.creditList = response.content;
          console.log(this.creditList)
          this.resultsLength = response.totalElements;
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch recharge requests:', error);
      }
    );
  }

  fetchWalletBalance() {
    let entityId = this.profile.entity.id;
    this.isLoadingWalletBalance = true;
    this.creditsService.fetchWalletBalance(entityId).subscribe(
      (response) => {
        this.isLoadingWalletBalance = false;
        this.walletBalance = response.result;
      }, (error) => {
        this.isLoadingWalletBalance = false;
        console.error('Failed to fetch wallet balance:', error);
      })
  }

  // get Credits
  fetchTaskCredits() {
    let entityId = this.profile.entity.id;
    this.isLoadingTaskCredit = true;
    this.creditsService.fetchTaskCreditBalance(entityId).subscribe(
      (response) => {
        console.log(response)
        this.isLoadingTaskCredit = false;
        response.remainCredits = response.taskCredits - response.usedCredits;
        this.totalCredits = response;
      }, (error) => {
        this.isLoadingTaskCredit = false;
        console.error('Failed to fetch wallet balance:', error);
      })
  }

  openTopUpPopup(forWhat: string) {
    const dialogRef = this.dialog.open(AddCreditComponent, {
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      autoFocus: true,
      minWidth: "500px",
      width: "500px",
      data: {
        "forWhat": forWhat,
        "currentPlan": (this.currentUserSubscription && this.currentUserSubscription.planMetaData && this.currentUserSubscription.planMetaData.name)
          ? this.currentUserSubscription.planMetaData.name
          : (this.currentUserSubscription && this.currentUserSubscription.subscriptionPlanName)
            ? this.currentUserSubscription.subscriptionPlanName
            : 'FREE_TRIAL'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.fetchWalletBalance();
        this.getCurrentUserSubscription();
        this.refreshPage();
      }
    });
  }

  withdraw() {
    let walletBalance = this.walletBalance && this.walletBalance.walletBalance ? this.walletBalance.walletBalance : 0;
    let obj = {
      "walletBalance": walletBalance
    }
    const dialogRef = this.dialog.open(WithdrawComponent, {
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      autoFocus: true,
      minWidth: "500px",
      data: obj
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.refreshPage();
      }
    });
  }

  verifyOTPSentBeforeUpdateStatus(row, status) {
    console.log(row);
    let obj = {
      "entityId": this.profile.entity.id,
      "amount": row.amount,
      "rechargeId": row.rechargeId
    }
    this.creditsService.paymentVerifyOTPSend(obj).subscribe(res => {
      let data = {
        step: 3,
      }
      const dialogRef = this.dialog.open(WithdrawComponent, {
        panelClass: 'add-edit-staff-dialog',
        disableClose: true,
        autoFocus: true,
        minWidth: "500px",
        data: data
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log(result)
        if (result) {
          this.updateCreditStatus(row, status, result);
        }
      });
    }, ((err: any) => {
      this.isLoading = false;
    }))
  }

  updateCreditStatus(row, status, otp) {
    console.log(row, status)
    this.creditsService.updateRechargeRequestStatus(row.rechargeId, status, otp).subscribe(
      (response) => {
        console.log(response)
        this.notify.showMessage("Credit requested " + status + " successfully!", 2000);
        this.refreshPage();
      }, (error) => {
        this.isLoading = false;
        console.error('Failed to update status:', error);
      })
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.fetchRechargeRequests();
  }

  refreshPage() {
    this.fetchRechargeRequests();
    if (this.profile.entity.entityType === 'ENTERPRISE' || this.profile.entity.entityType === 'AGENCY'
      || this.profile.entity.entityType === 'AGENT'
    ) {
      this.fetchWalletBalance();
      this.fetchTaskCredits();
      this.getCurrentUserSubscription();
      this.creditsService.setRefreshCreditsHeader(true);
    }
  }

  openPaymentGateway(obj) {
    console.log(obj);
    this.razorPayOptions.amount = obj.amount * 100
    this.razorPayOptions.currency = 'INR';
    this.razorPayOptions.key = environment.rezorpayKey;
    this.razorPayOptions.order_id = obj.checkoutOrder.razorPayOrderId;
    console.log("this.razorPayOptions", this.razorPayOptions)
    var rzp = new Razorpay(this.razorPayOptions);
    rzp.open()
    rzp.on('payment.failed', function (response) {
      console.log("response--", response)
      alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);
    });
  }

  razorPayOptions = {
    "key": '',
    "amount": 0,
    "currency": '',
    "name": '',
    "discription": "hours4u payment",
    "order_id": '',
    "handler": (response) => {
      console.log(response)
      let paymentOrderRequest = new EmployementPaymentOrder();
      paymentOrderRequest.razorpay_order_id = response.razorpay_order_id;
      paymentOrderRequest.razorpay_payment_id = response.razorpay_payment_id;
      paymentOrderRequest.razorpay_signature = response.razorpay_signature;
      this.isLoading = true;
      this.creditsService.updatePaymentStatusOrderId(response.razorpay_order_id, paymentOrderRequest).toPromise().then(res => {
        this.isLoading = false;
        this.zone.run(() => {
          this.refreshPage();
        })
      }, (err => {
        this.isLoading = false;
      }))
    },
    "modal": {
      "ondismiss": () => {
        this.zone.run(() => {
          this.refreshPage();
        })
      }
    }
  };

  // refresh individual row
  dataRefreshIndividualRow(res) {
    this.creditList.forEach((ele: any, index) => {
      if (ele.id == res.id) {
        this.creditList[index] = res;
        this.creditList = [...this.creditList];
        console.log(this.creditList)
        this.cdRef.detectChanges();
      }
    })
  }

  checkWalletHistory() {
    this.router.navigateByUrl('/credits/wallet-payout');
  }

  exportData() {
    this.isExporting = true;
    let params = new HttpParams();
    this.creditsService.exportCredits(this.profile.entity.id).subscribe(
      (response: any) => {
        this.isExporting = false;
        const blob = new Blob([response.body!], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);

        // Create a link element and trigger the download
        const a = document.createElement('a');
        a.href = url;
        a.download = 'credit-list.xlsx'; // specify the desired filename here
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.isExporting = false;
      }, (err => {
        this.isExporting = false;
      }))
  }

  fetchUsageData() {
    this.getAllCalls(1000, 0);
  }

  onTabChanged(event) {

  }

  clearWorkorderSelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedWorkorder = null;
    this.fetchUsageData();
  }

  clearTypeSelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedType = null;
    this.fetchUsageData();
  }

  onFilterChange(): void {
    // this.paginator.pageIndex = this.pageIndex;
    // this.paginator.pageSize = this.pageSize;
    this.fetchUsageData();
  }
  openUpgradePopup() {
    const dialogRef = this.dialog.open(UpgradeSubscriptionPopupComponent, {
      panelClass: 'upgrade-subscription-popup',
      disableClose: true,
      width: '100%',
      maxWidth: '100%',
      data: {
        "currentPlan": this.currentUserSubscription,
        // "isTrial": this.currentUserSubscription && this.currentUserSubscription.subscriptionStatus === 'TRIAL',
        // "isPaid": this.currentUserSubscription && this.currentUserSubscription.subscriptionStatus === 'ACTIVE',
        // "isFree": this.currentUserSubscription && this.currentUserSubscription.subscriptionStatus === 'FREE'
      },
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.refreshPage();

    });
  }

  getCurrentUserSubscription() {
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      this.getEntityDetails(this.profile.entity.id);
    }
  }

  getEntityDetails(entityId: string) {
    this.subscriptionPlansService.getEntityDetails(entityId).subscribe(
      (res) => {
        console.log("Trial Plan Info:", res);
        this.currentUserSubscription = {
          subscriptionStatus: res.subscriptionStatus,
          subscriptionPlanName: res.subscriptionPlanName,
          planMetaData: res.planMetaData // include this if backend sends metadata for paid plans
        };

        // Show trial-ended popup if subscriptionStatus is TRIAL_EXPIRED
        if (res.subscriptionPlanName === 'no_active_plan') {
          setTimeout(() => {
            const trialDialogRef = this.dialog.open(TrialEndedPopupComponent, {
              width: '640px',
              disableClose: true,
              data: {
                subscriptionStatus: 'TRIAL_EXPIRED',
                subscriptionPlanName: res.subscriptionPlanName,
              }
            });
            trialDialogRef.afterClosed().subscribe((result) => {
              if (result === true) {
                this.openUpgradePopup();
              }
            });
          }, 100);
        }

        this.fetchWalletBalance();
        this.fetchTaskCredits();

        if (res.subscriptionStatus === 'ACTIVE' && res.planMetaData && res.planMetaData.name) {
          this.subscriptionPlansService.fetchCurrentUserSubscription().subscribe(
            (response) => {
              this.currentUserSubscription = response;
              this.fetchWalletBalance();
              this.fetchTaskCredits();
              console.log("Fetched paid plan details:", this.currentUserSubscription);
            },
            (error) => {
              console.error("Failed to fetch current user's subscription details:", error);
            }
          );
        }
      },
      (error) => {
        console.error("Error fetching entity details:", error);
      }
    );
  }

  goToTopupHistory() {
    this.router.navigateByUrl('/credit-usage/credit-list');
  }
}